// Returned by native when the fetch function throws an exception.
export enum HttpErrorCodes {
	/**
	 * The HTTP request failed and the client returned an error.
	 */
	ERROR_HTTP_FETCH_FAILURE = 1000,

	/**
	 * The HTTP request failed with Inner Web Exception SendFailure
	 */
	ERROR_HTTP_SEND_FAILURE = 1001,

	ERROR_WINHTTP_TIMEOUT = 12002,

    ERROR_WINHTTP_INTERNAL_ERROR = 12004,

    ERROR_WINHTTP_INVALID_URL = 12005,

    ERROR_WINHTTP_NAME_NOT_RESOLVED = 12007,

    ERROR_WINHTTP_CANNOT_CONNECT = 12029,

    ERROR_WINHTTP_CONNECTION_ERROR = 12030,

    ERROR_WINHTTP_HEADER_NOT_FOUND = 12150,

    ERROR_WINHTTP_INVALID_SERVER_RESPONSE = 12152,

    ERROR_WINHTTP_SECURE_FAILURE = 12175,
}

// This Error is used to handle exception with HTTP Fetch failures
export class HttpRequestError extends Error {
	public errorCode: number;
	constructor(errorCode: number, description: string) {
		super();
		this.message = description;
		this.errorCode = errorCode;
	}
}
